import { useState, useEffect } from 'react';

const useConfig = () => {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    async function loadConf() {
      try {
        const response = await fetch('/config.json');
        const configData = await response.json();
        setConfig(configData);
        window._env_ = configData; // Store the config in the global object
      } catch (error) {
        console.error("Failed to load config:", error);
      }
    }
    loadConf();
  }, []);

  return config;
};

export default useConfig;